module.exports = __webpack_public_path__ + "static/media/poikiliamd_full2.e8544936.jpg";